const NewsLetterData = {
  email: {
    value: "",
    readonly: true,
    label: "",
    type: "text",
    noLabel: true,
    errorMsg: "Please enter a valid email",
    placeholder: "E-mail",
    noAstrics: true,
    validation: {
      email: true
    },
    maxLength: "255",
    valid: true
  }
};

export default NewsLetterData;
